import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ContactUsForm } from "../../website/services/website.services"
import {
  SWAL_SETTINGS,
  PHONE_NO_LENGTH
} from "../../../utils/Constants";
import {
  capitalizeFirstLetter,
  globalLoader,
  handleServerValidations,
} from "../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../utils/customError";
import PhoneInput from "../../../utils/PhoneInput";
import { PHONE_VALIDATION } from "../../../utils/commonValidations";
import { useSelector } from "react-redux";

const WebsiteContactUs = ({ id }) => {

  const navigate = useNavigate();
  const { t } = useTranslation();
  const [globalData, setGlobalData] = useState({})
  const getGlobalData = useSelector((state) => state.globalData?.data);

  useEffect(() => {
    if(getGlobalData){
      const globalSettingData = JSON.parse(getGlobalData);
    setGlobalData(globalSettingData)
    }
  },[getGlobalData]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("website.contact_us.web_contact_us_form_validation_name_required"),
    email: Yup.string()
    .trim()
    .required("website.contact_us.web_contact_us_form_validation_email_required")
    .email("website.contact_us.web_contact_us_form_validation_email_invalid_format")
    .matches(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/, "website.contact_us.web_contact_us_form_validation_email_invalid_format")
    .test('no-uppercase', "website.contact_us.web_contact_us_form_validation_email_not_contain_uppercase", function (value) {
      if (value) {
        return !/[A-Z]/.test(value);
      }
    }),
    phone_number: PHONE_VALIDATION,
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      email: "",
      phone_number: "",
      note: "",
    },
    validateOnBlur: false,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      let formData = new FormData();
      formData.append("name", values.name)
      formData.append("phone_number", values.phone_number);
      formData.append("email", values.email);
      formData.append("note", values.note.trim());

      ContactUsForm(formData)
        .then((response) => {
          globalLoader(false);
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm({ values: "" });
            navigate(`/`);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          globalLoader(false);
          console.log("error ====> ", error);
        });
    },
  });


  return (
    <div className="home-page-section">
      <div className="heading-banner-page">
        <div className="container">
          <h1>Contact Us</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
            <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
          </ol>
        </nav>
      </div>
    </div>
    <section id={id} className="contact-sec innerpage-padding">
        <div className="container w-75">
          <div className="d-flex align-items-center justify-content-center">
            <div className="row">
              <div className="col-md-6">
                <div className="contact-us-text">
                  <div className="heading-section d-flex flex-column gap-3 mb-5 me-5">
                    <h4>Get in Touch</h4>
                    <p>{t("website.contact_us.web_contact_us_content_text")}</p>
                    <h3 className="mt-3"><i className="ti ti-map-pin me-2"></i>{capitalizeFirstLetter(globalData?.address)}</h3>
                    <h3 className="mt-3"><i className="ti ti-phone-call me-2"></i>{globalData?.phone_number}</h3>
                    <h3 className="mt-3"><i className="ti ti-mail me-2"></i>{globalData?.admin_email}</h3>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body m-4">
                    <form onSubmit={formik.handleSubmit}>
                      <div className="contact-form">
                        <div className="contact-form-box">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label htmlFor="name" className="form-label ">
                                  {t("website.contact_us.web_contact_us_form_label_name")} <span>*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder={t("website.contact_us.web_contact_us_form_placeholder_name")}
                                  name="name"
                                  id="name"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.name}
                                />
                                <span className="text-danger d-flex text-left">
                                  <CustomError name="name" form={formik} />
                                </span>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label htmlFor="phone_number" className="form-label ">
                                  {t("website.contact_us.web_contact_us_form_label_contact_number")} <span>*</span>
                                </label>
                                <PhoneInput
                                  type="text"
                                  className="form-control"
                                  placeholder={t("website.contact_us.web_contact_us_form_placeholder_contact_number")}
                                  name="phone_number"
                                  id="phone_number"
                                  // onChange={formik.handleChange}
                                  onChange={(e) => { formik.setFieldValue('phone_number', e?.phone_number) }}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.phone_number}
                                />
                                <span className="text-danger d-flex text-left">
                                  <CustomError name="phone_number" form={formik} shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                                </span>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <label className="form-label ">
                                  {t("website.contact_us.web_contact_us_form_label_email")} <span>*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder={t("website.contact_us.web_contact_us_form_placeholder_email")}
                                  name="email"
                                  id="email"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.email}
                                />
                                <span className="text-danger d-flex text-left">
                                  <CustomError name="email" form={formik} />
                                </span>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="mb-3">
                                <label className="form-label ">{t("website.contact_us.web_contact_us_form_label_note")}</label>
                                <textarea
                                  className="form-control"
                                  placeholder={t("website.contact_us.web_contact_us_form_placeholder_type_your_message_here")}
                                  style={{ height: "120px" }}
                                  name="note"
                                  id="note"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.note}
                                ></textarea>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <button className="btn btn-primary w-25">
                                {t("website.contact_us.web_contact_us_form_btn_submit")}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default WebsiteContactUs;